import script from "./PropertyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyCard.vue?vue&type=script&setup=true&lang=js"

import "./PropertyCard.vue?vue&type=style&index=0&id=411b0602&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411b0602"]])

export default __exports__